import '../../App.css'


export default function TutorialsHome() {
    return (
      <h2>Tutorials Home</h2>
    );
  }